export const AUTH_TOKEN_REFRESH_INTERVAL = 540000; // every 9 minutes
export const DATE_FORMAT_SHORT = 'M/d/yy';
export const DATE_FORMAT_ABBR = 'PP'; // Jan 19, 2022
export const DATE_FORMAT_INPUT = 'MM/dd/yyyy'; // used to set dates on Calendar/DatePicker/DateRangePicker
export const DATE_FORMAT_DOB = 'M/d/yyyy';
export const DATE_FORMAT_SERVER = 'MM-dd-yyyy';
export const DATE_ISO_FORMAT_SERVER = 'yyyy-MM-dd';

export const IDLE_EXPIRE_AFTER = 2700000; // every 45 minutes
export const IDLE_WARN_AFTER = 2640000; // every 44 minutes
export const TIME_FORMAT = 'h:mm a zzz';
export const DATE_TIME_FORMAT = `${DATE_FORMAT_SHORT}, ${TIME_FORMAT}`;
export const TERMS = {
    acuityRank:
        'Acuity Rank is calculated using Frailty, Mortality, and Hospitalization Risk as as well as changes in condition, follow-ups and a number of other variables. Each patient will be ranked amongst the rest of the population (i.e. if there are 100 Enrollees, each will be assigned a unique rank between 1 and 100).',
    frailty:
        'Frailty is a measure of clinical syndrome of losses across multiple body systems. As frailty increases, so do the risks for the negative outcomes we all want to avoid.',
    hospitalization:
        'Our frailty-informed Hospitalization Risk metric uses advanced machine learning models to calculate the increased likelihood of a frail individual being hospitalized.',
    mortality:
        'Our frailty-informed Mortality Risk metric uses machine learning models to calculate the increased likelihood of a frail individual expiring when compared to a pre-frail individual.',
};

// Radio button options for tag filters.
// 'Any of' updates the filter query param key "isIncludeAllTags" with value 'false' (string).
// 'All of' updates the filter query param key "isIncludeAllTags" with value 'true' (string).
export const TAG_FILTER_OPTION = [
    {label: 'Any of', value: 'false'},
    {label: 'All of', value: 'true'},
] as const;
